import * as React from 'react';

import { RecentlyViewedModel } from 'models';

import { classNames } from 'uitk-react-utils';

export interface ListingNameProps {
  name: string;
  ariaHidden?: boolean;
  visuallyHidden?: boolean;
  recentlyViewed?: RecentlyViewedModel;
  lineCount?: number;
}

export const ListingName: React.FunctionComponent<ListingNameProps> = ({
  name,
  ariaHidden = false,
  visuallyHidden = false,
  recentlyViewed = null,
  lineCount = 1
}) => {
  const truncateClass = lineCount && lineCount >= 2 && lineCount <= 9 ? `truncate-lines-${lineCount}` : 'truncate';
  const classes = classNames(`${truncateClass} all-b-padding-half`, {
    'uitk-type-500 pwa-theme--grey-700': recentlyViewed,
    'pwa-theme--grey-900 uitk-type-heading-500': !recentlyViewed
  });

  return (
    <h3 className={classes} data-stid="content-hotel-title" aria-hidden={ariaHidden} hidden={visuallyHidden}>
      {name}
    </h3>
  );
};
ListingName.displayName = 'ListingName';
